import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

function map(item)
{
    return {...item, id: item.categoryID}
}

async function getData()
{
    let indexed = {};

    let response = await api.procedures.items.categories.getAll();
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.categoryID] = item;
    });
    
    return {array: data, indexed: indexed};
}

const CategoriesCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {}
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        delete: () => {},
    }
});

function CategoriesCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalUpdate = React.useCallback((categoryID, categoryData) => {
        let tmp = {...data};
        Object.keys(categoryData).forEach((key) => {
            tmp.indexed[categoryID][key] = categoryData[key];
        })
        setData(tmp);
    }, [data]);

    const internalAdd = React.useCallback(async (categoryID, item) => {
        if(data.indexed[categoryID] !== undefined) return internalUpdate(categoryID, item);

        let tmp = {...data};
        
        item = map(item);
        let index = tmp.array.push(item);
        tmp.indexed[item.id] = tmp.array[index-1];

        setData(tmp);
        
    }, [data, internalUpdate]);

    

    const internalDelete = React.useCallback((categoryID) => {
        let tmp = {...data};
        let item = tmp.indexed[categoryID];

        // remove from array
        let index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);

        delete tmp.indexed[categoryID];
        setData(tmp);
    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.procedures.items.categories.post(data);
        if(result.ok)
        {
            let item = await result.json();
            internalAdd(item.categoryID, item);
        }
    }, [internalAdd]);

    const update = React.useCallback(async (categoryID, data) => {
        let result = await api.procedures.items.categories.updateSingle(categoryID, data);
        if(result.ok) internalUpdate(categoryID, data);

    }, [internalUpdate]);

    const remove = React.useCallback(async (categoryID) => {
        let result = await api.procedures.items.categories.deleteSingle(categoryID);
        if(result.ok) internalDelete(categoryID);
    }, [internalDelete]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.categoryID, message);
        // const handleEnable = (message) => internalUpdate(message.categoryID, {disabled: false});
        // const handleDisable = (message) => internalUpdate(message.categoryID, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.categoryID, message);
        const handleDelete = (message) => internalDelete(message.categoryID, message);

        Singletons.NotificationsSocket.on('procedures.items.categories.created', handleCreate);
        // Singletons.NotificationsSocket.on('procedures.items.categories.disabled', handleDisable);
        // Singletons.NotificationsSocket.on('procedures.items.categories.enabled', handleEnable);
        Singletons.NotificationsSocket.on('procedures.items.categories.updated', handleUpdate);
        Singletons.NotificationsSocket.on('procedures.items.categories.deleted', handleDelete);

        return () => {
            Singletons.NotificationsSocket.off('procedures.items.categories.created', handleCreate);
            // Singletons.NotificationsSocket.off('procedures.items.categories.disabled', handleDisable);
            // Singletons.NotificationsSocket.off('procedures.items.categories.enabled', handleEnable);
            Singletons.NotificationsSocket.off('procedures.items.categories.updated', handleUpdate);
            Singletons.NotificationsSocket.off('procedures.items.categories.deleted', handleDelete);
        }

    }, [internalAdd, internalUpdate, internalDelete]);

    return <CategoriesCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, delete: remove}}} >
        {props.children}
        </CategoriesCtx.Provider>
}

export {CategoriesCtx, CategoriesCtxProvider};